import * as React from 'react';
import type { RefObject } from 'react';

import {
  confirmPasswordToDisableTwoFactorAuthentication,
  confirmPasswordToEnableTwoFactorAuthentication,
} from 'bundles/account-settings/actions/SettingsActionCreators';
import CodeConfirmationModal from 'bundles/account-settings/components/sections/two-factor/CodeConfirmationModal';
import PasswordConfirmationModal from 'bundles/account-settings/components/sections/two-factor/PasswordConfirmationModal';
import { TwoFactorAuthenticationStatus } from 'bundles/account-settings/constants/SettingsConstants';

import _t from 'i18n!nls/account-settings';

type Props = {
  state: string;
  qrCode?: string | null;
  invalidFields: string[];
  updating: boolean;
  returnFocusRef?: RefObject<HTMLElement>;
};

const TwoFactorAuthenticationModal = ({ state, qrCode, invalidFields, updating, returnFocusRef }: Props) => {
  if (state === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_PASSWORD) {
    return (
      <PasswordConfirmationModal
        title={_t('Enable Two-Factor Auth')}
        invalidFields={invalidFields}
        updating={updating}
        submitAction={confirmPasswordToEnableTwoFactorAuthentication}
        returnFocusRef={returnFocusRef}
      />
    );
  }

  if (state === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_CODE && qrCode) {
    return (
      <CodeConfirmationModal
        qrCode={qrCode}
        invalidFields={invalidFields}
        updating={updating}
        returnFocusRef={returnFocusRef}
      />
    );
  }

  if (state === TwoFactorAuthenticationStatus.DISABLING_CONFIRMING_PASSWORD) {
    return (
      <PasswordConfirmationModal
        title={_t('Disable Two-Factor Auth')}
        invalidFields={invalidFields}
        updating={updating}
        submitAction={confirmPasswordToDisableTwoFactorAuthentication}
        returnFocusRef={returnFocusRef}
      />
    );
  }

  return null;
};

export default TwoFactorAuthenticationModal;
